import { render } from "./DocumentToolbar.vue?vue&type=template&id=5c3bd66c&scoped=true"
import script from "./DocumentToolbar.vue?vue&type=script&lang=js"
export * from "./DocumentToolbar.vue?vue&type=script&lang=js"

import "./DocumentToolbar.vue?vue&type=style&index=0&id=5c3bd66c&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3bd66c"]])

export default __exports__